export const types = {
  GET_TRANSACTIONS: 'GET_TRANSACTIONS',
  GET_TRANSACTIONS_PROCESSING: 'GET_TRANSACTIONS_PROCESSING',
  GET_TRANSACTIONS_SUCCESS: 'GET_TRANSACTIONS_SUCCESS',
  GET_TRANSACTIONS_FAILURE: 'GET_TRANSACTIONS_FAILURE',
  GET_TRANSACTIONS_RESET: 'GET_TRANSACTIONS_RESET',
};
